import React, { ReactNode } from 'react';
import DateInput from '~/reusable-components/forms/ContactHostForm/DateTimeInput/DateInput';
import TimeInput from '~/reusable-components/forms/ContactHostForm/DateTimeInput/TimeInput';
import Label from '~/reusable-components/inputs/Label';

const CSS = require('./DateTimeInput.module.scss');

interface DateTimeInputProps {
  label: string;
  defaultValues: {
    date?: string;
    time?: string;
  };
  durationComponent?: ReactNode;
}

function DateTimeInput({
  label,
  defaultValues,
  durationComponent,
}: DateTimeInputProps) {
  return (
    <>
      <Label>{label}</Label>
      <div className={CSS.DateTimeInput}>
        <DateInput defaultValue={defaultValues.date} />
        <TimeInput defaultValue={defaultValues.time} />
        {durationComponent && durationComponent}
      </div>
    </>
  );
}

export default DateTimeInput;
